<div #chartTable></div>


// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-eia-pareto/display-eia-pareto.component.html